module.exports = __webpack_public_path__ + "static/media/default.9ba86092.xml";